import { RouteHandler } from 'wee-routes';
import Vue from 'vue';
import preReg from './index.vue';

// Create component constructor
export const FormSearch = Vue.extend(preReg);


// Register and mount component
export default new RouteHandler({
	init() {
		new FormSearch().$mount('.js-preReg');
	}
});
